import { LinkRegular } from "@fluentui/react-icons";
import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import { formatDate } from "../../helper/DateFormat";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";

const EngagementTable = (props: any) => {
  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
      const rowgrpElements = document.querySelectorAll("[role=\"grid\"]");
      rowgrpElements.forEach(function (element) {
        element.setAttribute("aria-busy", "true");
      });
    }, 1000);
  }, []);
  const showNoData = () => {
    const rootStyle = {
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      fontWeight: 600,
      justifyContent: "center",
      padding: 200
    };
    return <div style={rootStyle}>{`Program details are not available for ${props.tenantName} .`} </div>;
  };

  const columns: GridColDef[] = [
    {
      headerName: "Program Link",
      field: "programLink",
      width: 130,
      sortable: true,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 26,
            cursor: "pointer"
          }}
          href={params.row.programLink}
          target="_blank"
          rel="noopener noreferrer"
          title={params.row.programLink}
          tabIndex={params.row.tabIndex}
        >
          <LinkRegular />
        </a>
      )
    },
    {
      headerName: "Program Name",
      field: "programName",
      width: 270,
      sortable: true
    },
    {
      headerName: "Program Description",
      field: "programDescription",
      width: 240,
      sortable: true
    },
    {
      headerName: "Program Status",
      field: "programState",
      width: 190,
      sortable: true,
      align: "left",
      headerAlign: "left"
    },

    {
      headerName: "Program Owner",
      field: "programOwner",
      width: 170,
      sortable: true
    },
    {
      headerName: "Start Date",
      field: "programStart",
      type: "date",
      width: 150,
      sortable: true,
      valueGetter: (value, row) => new Date(row.programStart),
      renderCell: (params) => formatDate(params.row.programStart)
    },
    {
      headerName: "End Date",
      field: "programEnd",
      type: "date",
      width: 150,
      sortable: true,
      valueGetter: (value, row) => new Date(row.programEnd),
      renderCell: (params) => formatDate(params.row.programEnd)
    },
    {
      headerName: "Product",
      field: "productName",
      minWidth: 150,
      flex: 1,
      sortable: true
    }
  ];

  return props?.tableData && props?.tableData.length > 0 ? (
    <div style={{ height: 600 }}>
      <CustomDataGrid
        columns={columns}
        enableUrlParams
        exportCsvButtonProps={{
          fileNamePrefix: "programs"
        }}
        getRowId={(row) => row.id}
        rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
        kustoLink={props.kustoLink}
        TabName={`Customer View - Customer Engagements Tab - Program Table for ${props.tenantName}`}
      />
    </div>
  ) : (
    showNoData()
  );
};

export default EngagementTable;
